var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputeStopping({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "643CE5D6-D085-4381-8E7A-D58B59BBEEDD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-56.000000, -726.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "STOPPING/DELETING",
    transform: "translate(19.000000, 626.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/16x16/Compute/Paused-Copy-2",
    transform: "translate(37.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-box",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58019823,18 C8.86841214,18 9.10701038,17.7753562 9.12335697,17.4876739 C9.38835784,12.8127254 13.2574502,9.10887097 18,9.10887097 C20.4569948,9.10887097 22.6795113,10.1033552 24.2879452,11.7120548 L21.8325451,14.1674992 C21.4895768,14.5104675 21.7324721,15.0967742 22.217421,15.0967742 L28.7056452,15.0967742 C29.006263,15.0967742 29.25,14.8530372 29.25,14.5524194 L29.25,8.0641952 C29.25,7.57924627 28.663649,7.33635096 28.320725,7.67927502 L25.9543674,10.0456326 C23.9187071,8.00957366 21.1066944,6.75 18,6.75 C11.9770557,6.75 7.05956637,11.4830696 6.76404301,17.4326536 C6.74867101,17.7419099 6.99834418,18 7.30799915,18 L8.58019823,18 Z M18,29.25 C24.0229886,29.25 28.9404336,24.5169304 29.235957,18.5673464 C29.251329,18.2580901 29.0016558,18 28.6920009,18 L27.4198018,18 C27.1315879,18 26.8929896,18.2246438 26.876643,18.5123261 C26.6116422,23.1872746 22.7425498,26.891129 18,26.891129 C15.5430052,26.891129 13.3204887,25.8966448 11.7120548,24.2879452 L14.1674549,21.8325008 C14.5104232,21.4895325 14.2675279,20.9032258 13.782579,20.9032258 L7.29435484,20.9032258 C6.99373701,20.9032258 6.75,21.1469628 6.75,21.4475806 L6.75,27.9358048 C6.75,28.4207537 7.33635096,28.663649 7.67927502,28.3206807 L10.0456326,25.9543674 C12.0812929,27.9904263 14.8933499,29.25 18,29.25 Z",
    id: "\\uF2F1",
    fill: "#F7981C",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputeStopping);
export default __webpack_public_path__ + "static/media/compute-stopping.1555b74f03d70552d099e6b73e788072.svg";
export { ForwardRef as ReactComponent };